import { IBetslipState } from '../../../base/store/state';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { getPickPrice, getPickPriceIds } from '../../picks/services/betslip-pick-helpers';
import { IRewardToken, RewardTokenContext } from '../../reward-tokens/reward-tokens.model';
import { getSelectedBetStationTokenForContext } from '../../reward-tokens/services/betstation-reward-tokens.utils';
import { getAllAssignedTokens } from '../../reward-tokens/services/linear-reward-tokens.utils';
import { IRewardTokensState } from '../../reward-tokens/state';
import { IBetslipTypeState } from '../../types/state';
import { PickInfo } from '../models';

export type BetslipStateInput = Pick<IBetslipState, 'types' | 'picks' | 'rewardTokens' | 'errors' | 'base'>;
export type BetslipStateOverrides = Pick<IBetslipState, 'types' | 'rewardTokens' | 'quickBet' | 'picks'>;

export interface InputBuilderGeneratorOptions<T> {
    picksSelector?: (BetslipStateInput: BetslipStateInput) => [pickIdString: string, pick: T][];
}

export interface ComboInputBuilderGeneratorOptions<T> extends InputBuilderGeneratorOptions<T> {
    isSportcastAsComboEnabled: boolean;
}

export default class BaseInputBuilder {
    protected getPickInfo(pick: BetslipPick): Pick<PickInfo, 'pick' | 'price' | 'priceIds'> {
        return {
            pick,
            price: getPickPrice(pick),
            priceIds: getPickPriceIds(pick),
        };
    }

    protected getSelectedTokenIfEligible(
        tokenId: string | null,
        rewardTokens: IRewardTokensState,
        types: IBetslipTypeState,
        context: RewardTokenContext,
    ): IRewardToken | null {
        if (!tokenId) {
            //in case provided type token id is null, return the first selected token. This was added to fix betstation tokens since it can be added before populating types picks
            return getSelectedBetStationTokenForContext(context, types, rewardTokens.betstationTokens, rewardTokens.tokens);
        }

        const tokens = getAllAssignedTokens(rewardTokens.tokens, types);
        const selectedToken = tokens.find((t) => t.userTokenId === tokenId);

        return selectedToken ?? null;
    }
}
